import { Component } from '@angular/core';
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor(
      private matIconRegistry: MatIconRegistry,
      private domSanitizer: DomSanitizer
    )
    {
      this.matIconRegistry.addSvgIcon(
        `icon_speed_limit_50`,
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/speed-limit/CA-BC_road_sign_R-004-050.svg")
      );
      this.matIconRegistry.addSvgIcon(
        `icon_speed_limit_70`,
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/speed-limit/CA-BC_road_sign_R-004-070.svg")
      );
      this.matIconRegistry.addSvgIcon(
        `icon_speed_limit_90`,
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/speed-limit/CA-BC_road_sign_R-004-090.svg")
      );
    }
}
